// Appel des fonctions du module Dépenses (europe-west3), sorti de
// depensesShared.js au lot L10 : App.jsx l'emploie au démarrage (accès aux
// notes de frais) et tirait tous les libellés du module dans le bundle principal.
// `options` est passé à httpsCallable (ex. { timeout: 540000 } pour l'envoi
// de l'export comptable mensuel, qui assemble le PDF des pièces).
export async function callDepenses(nom, aramisSession, data = {}, options) {
  const { httpsCallable } = await import("firebase/functions");
  // Jeton d'abord (course au démarrage mesurée le 10/09/2026 sur apNdfMonAcces).
  const garde = await import("./authGuard");
  await garde.attendreAuthPrete();
  const fn = (await import("./RHAuth")).rhFunctions("europe-west3");
  try {
    const res = await httpsCallable(fn, nom, options)({ aramisUserId: aramisSession?.id, ...data });
    return res.data;
  } catch (e) {
    garde.signalerSiDefi(e); // défi du mode strict → bannière de reconnexion
    throw e;
  }
}
